import styles from './SpeechBubbleTextIcon.module.scss';

function SpeechBubbleTextIcon({
  bgColor,
  text,
  size = 'default',
  direction = 'right',
}: {
  bgColor: string;
  text: string;
  size: 'xSmall' | 'small' | 'default' | 'large';
  direction: 'left' | 'right';
}) {
  return (
    <div
      className={`${styles.componentStyle} ${styles[`${size}Container`]} ${styles[`${direction}Container`]}`}
      style={{ backgroundColor: `var(--color-${bgColor})` }}
    >
      {/* {isLoading ? (
        <div className={styles.textCommon}>
          <ProgressAnime />
        </div>
      ) : (
        <span className={`${styles[`${size}Text`]} ${styles.textCommon}`}>{text}</span>
      )} */}
      <span className={`${styles[`${size}Text`]} ${styles.textCommon}`}>{text}</span>
    </div>
  );
}

export default SpeechBubbleTextIcon;
